import React, { PropsWithChildren } from 'react';
import SettingsApplicationsIcon from '@mui/icons-material/SettingsApplications';
import { Typography } from '@mui/material';
import { Box } from '@mui/system';

import { Dialog } from '@paragon/popup-state';

export function SettingsErrorDialog({ children }: PropsWithChildren) {
  return (
    <Dialog insistent maxWidth="sm" variant="design" cancelText="Close" onCancel="close">
      <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
        <SettingsApplicationsIcon sx={{ fontSize: '96px' }} color="error" />
      </Box>

      <Typography sx={{ marginY: 2 }}>{children}</Typography>
    </Dialog>
  );
}
